import { Component, OnInit } from '@angular/core';
import { Application } from '../../shared/user.model';
import { UserService } from '../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { Search } from '../../shared/user.model';
import { ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-request-app-records',
  templateUrl: './request-app-records.component.html',
  styleUrls: ['./request-app-records.component.css']
})
export class RequestAppRecordsComponent implements OnInit {

  r : any = {}
  RecordList : any = {}
  FromDate : Date 
  ToDate : Date
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute,private errorHandler: ErrorHandler,
    private formBuilder:ReactiveFormsModule, private fb : FormBuilder ) { }

  ngOnInit() {
  }

  GetList(DateFrom){    
    document.getElementById('loader-spinner').style.display = "block";     
     
   
    
   this.userService.GetAllRequestedReports(DateFrom.value.fromDate,DateFrom.value.toDate)
    .subscribe(
      (data:any) =>{       
        this.FromDate = DateFrom.value.fromDate;
        this.ToDate = DateFrom.value.toDate;     
        this.RecordList = data.Result;              
        document.getElementById('loader-spinner').style.display = "none";                      
      }, (error) => {         
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401) {
          this.errorHandler.HandlerError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      }
    )  
  }

  myFunction(){
    window.print();
  }

}



// WEBPACK FOOTER //
// ./src/app/Godown/request-app-records/request-app-records.component.ts